import { CardHolderInfo } from "./CardHolderInfo"
import { CardScreenStateModel } from "./CardScreenStateModel"
import { CardValidationModel } from "../../models/CardValidationModel"

export const sendValidateCardEvent = (iframeId: string) => {
  const eventData = {
    eventType: "SRCI_CARD_INPUT_VALIDATE_CARD",
  }
  const iframe = document.getElementById(`${iframeId}`) as HTMLIFrameElement
  iframe.contentWindow && iframe.contentWindow.postMessage(eventData, "*")
}

export const sendGetEncryptedCardEvent = (iframeId: string, cardHolderInfo?: CardHolderInfo) => {
  const eventData = {
    eventType: "SRCI_CARD_INPUT_GET_ENCRYPTED_CARD",
    cardholderInfo: cardHolderInfo,
  }
  const iframe = document.getElementById(`${iframeId}`) as HTMLIFrameElement
  iframe.contentWindow && iframe.contentWindow.postMessage(eventData, "*")
}

export const eventResponseHandler = (
  event: any,
  componentId: string,
  responseMethod?: (cardScreenState: CardScreenStateModel) => void | Promise<void>,
  enterOnClick?: () => void | Promise<void>,
  validationResponseMethod?: (cardValidation: CardValidationModel) => void | Promise<void>
): void | Promise<void> => {
  const eventModel = event.data
  if (typeof eventModel !== "object" || eventModel === null) return
  if (eventModel.id !== componentId) return
  switch (eventModel.eventType) {
    case "SRCI_CARD_INPUT_VALIDATE_CARD_RESPONSE":
      const cardValidation: CardValidationModel = {
        cardBrand: eventModel.cardBrand,
        isCardNumberValid: eventModel.isCardNumberValid,
        isPanExpirationDateValid: eventModel.isPanExpirationDateValid,
        isCardSecurityCodeValid: eventModel.isCardSecurityCodeValid,
      }
      return typeof validationResponseMethod === "function" ? validationResponseMethod(cardValidation) : undefined
    case "SRCI_CARD_INPUT_GET_ENCRYPTED_CARD_RESPONSE":
      const cardScreenState: CardScreenStateModel = {
        encryptedCard: eventModel.encryptedCard,
      }
      return typeof responseMethod === "function" ? responseMethod(cardScreenState) : undefined
    case "SRCI_CARD_INPUT_ON_ENTER_CLICK":
      return typeof enterOnClick === "function" ? enterOnClick() : undefined
  }
}
